import { cn } from '@/app/_lib/utils';
import { CarouselPrevious, CarouselNext, type CarouselApi } from './carousel';
import { useCarouselAutoplay } from './use-carousel-autoplay';

interface CarouselNavigationProps {
  className?: string;
  variant?: 'default' | 'outline' | 'ghost' | 'link' | 'destructive' | 'secondary';
  api?: CarouselApi;
}

const defaultCarouselNavigationClasses =
  'bg-custom-background-dark-input-30 text-foreground relative inset-0 translate-x-0 translate-y-0 cursor-pointer';

const designTokenCarouselNavigationClasses =
  'border-carousel-arrow-button-width w-carousel-arrow-button-width h-carousel-arrow-button-height rounded-carousel-arrow-button shadow-carousel-arrow-button-mobile lg:shadow-carousel-arrow-button-desktop';

const carouselNavigationClasses = cn(
  defaultCarouselNavigationClasses,
  designTokenCarouselNavigationClasses
);

export function CarouselNavigation({ className, variant = 'outline', api }: CarouselNavigationProps) {
  const { resetAutoplay, autoplayContainerHandlers } = useCarouselAutoplay(api);

  return (
    <div
      className={cn('hidden items-center gap-2 md:flex', className)}
      {...autoplayContainerHandlers}
    >
      <CarouselPrevious
        variant={variant}
        className={carouselNavigationClasses}
        onClickCapture={resetAutoplay}
      />
      <CarouselNext
        variant={variant}
        className={carouselNavigationClasses}
        onClickCapture={resetAutoplay}
      />
    </div>
  );
}
